export default __webpack_public_path__ + "static/professional-intelligence-v5-2854e2e91cbae68535f33f1faded2a6b.svg";